import React from "react";
import styled from "styled-components";

const ButtonWrapper = styled.div`
    cursor: pointer;
`;

const ButtonLabel = styled.span`
    text-decoration: underline;
`;

interface LinkButtonProps {
    readonly label: string;
    readonly handleClick: () => void;
    readonly className?: string;
}
export default function LinkButton(props: LinkButtonProps) {
    return (
        <ButtonWrapper className={props.className}>
            <ButtonLabel onClick={props.handleClick}>{props.label}</ButtonLabel>
        </ButtonWrapper>
    );
}
